// Browser-owned transport correlation shared by human POST surfaces. The identifier is never authority:
// each server route binds it to authenticated, server-owned context before any durable operation may use it.

/** Fail closed if the browser cannot mint a cryptographically random RFC 4122 v4 identity. */
export function mintTransportRequestId(): string {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi === undefined || typeof cryptoApi.randomUUID !== 'function') {
    throw new Error('secure transport request identity is unavailable');
  }
  return cryptoApi.randomUUID();
}
